var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58337 5.50065H7.91671V4.16732H6.58337M7.25004 12.834C4.31004 12.834 1.91671 10.4406 1.91671 7.50065C1.91671 4.56065 4.31004 2.16732 7.25004 2.16732C10.19 2.16732 12.5834 4.56065 12.5834 7.50065C12.5834 10.4406 10.19 12.834 7.25004 12.834ZM7.25004 0.833984C6.37456 0.833984 5.50765 1.00642 4.69882 1.34145C3.88998 1.67649 3.15505 2.16755 2.536 2.78661C1.28575 4.03685 0.583374 5.73254 0.583374 7.50065C0.583374 9.26876 1.28575 10.9645 2.536 12.2147C3.15505 12.8338 3.88998 13.3248 4.69882 13.6598C5.50765 13.9949 6.37456 14.1673 7.25004 14.1673C9.01815 14.1673 10.7138 13.4649 11.9641 12.2147C13.2143 10.9645 13.9167 9.26876 13.9167 7.50065C13.9167 6.62517 13.7443 5.75827 13.4092 4.94943C13.0742 4.14059 12.5831 3.40566 11.9641 2.78661C11.345 2.16755 10.6101 1.67649 9.80126 1.34145C8.99243 1.00642 8.12552 0.833984 7.25004 0.833984ZM6.58337 10.834H7.91671V6.83398H6.58337V10.834Z",
    fill: "#BC2525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/info-outline.89d7ae5d2ed5e7ffd5e2c6167f953519.svg";
export { ForwardRef as ReactComponent };